import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage";
import CreateHashPage from "./pages/CreateHashPage";
import SignHashPage from "./pages/SignHashPage";
import RecoverTxPage from "./pages/RecoverTxPage";
import FinalizeTxPage from "./pages/FinalizeTxPage";
import { WalletProvider } from "./contexts/WalletContext";

import "./App.css";

function App() {
  return (
    <WalletProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<CreateHashPage />} />
            {/* <Route path="/create-hash" element={<CreateHashPage />} /> */}
            <Route path="/sign-hash" element={<SignHashPage />} />
            <Route path="/recover-tx" element={<RecoverTxPage />} />
            <Route path="/finalize-tx" element={<FinalizeTxPage />} />
          </Routes>
        </div>
      </Router>
    </WalletProvider>
  );
}

export default App;
